import axios from "../../../axios";
import { addNotification } from "../../../Utilities/notifications";

export const deleteWorker = async (worker_id) => {
  try {
    let { data } = await axios.delete(`/v1/worker/${worker_id}`);
    return data;
  } catch (e) {
    console.log("error while deleting worker ....", e.response);
    if (e.response) {
      let {
        response: { status },
      } = e;
      if (status === 405) {
        addNotification({
          title: "Techforce.ai",
          message: "Please write for technical support",
          type: "danger",
        });
      } else if (status === 403) {
        addNotification({
          title: "Techforce.ai",
          message: "You don't have enough permission to delete worker",
          type: "danger",
        });
      }
    } else {
      addNotification({
        title: "Techforce.ai",
        message: "working on deleting your e-worker",
        type: "info",
      });
    }
  }
};
